export type BoardMessage = {
  id: string
  time_posted: string
  content: string
  author: string
  task_id: string
  program?: string
  kind: 'post' | 'reply' | 'correction'
}

export type BoardThread = BoardMessage & {
  activity_at: string
  replies: BoardMessage[]
  superseded: boolean
  correction: BoardMessage | null
}

export type AuthorMessage = { thread_id: string; message: BoardMessage }

export const messageLink = (threadId: string, replyId?: string) =>
  `/eng/agents/messages?thread=${encodeURIComponent(threadId)}` +
  (replyId ? `&reply=${encodeURIComponent(replyId)}` : '')
